module.exports = __webpack_public_path__ + "img/shareproperlly.2862a76.png";